<template>
  <div class="multi-select-filter">
    <label>
      {{ label }}
    </label>

    <selected-value-accented v-for="value in values" :key="value[1]" class="selected-value"
                             :value="value[1]" :label="value[0]" :display-variety="selectedValueDisplayVariety"
                             @remove-item="removeItem" />

    <div ref="container" :class="['chooser-container', {block: chooserOpen}]">
      <light-button v-if="showAddButton" :label="i18n.t('administrative.add')" class="btn-sm" @click="showChooser" />
      <multi-select-chooser v-if="chooserOpen" class="chooser" :options="options" :existing-values="values"
                            @item-selected="itemSelected" @clicked-outside="hideChooser" />
    </div>
  </div>
</template>

<script>
import LightButton from '../components/buttons/light-button'
import MultiSelectChooser from '../filterable-list/filters/components/multi-select-chooser'
import SelectedValueAccented from '../components/selected-value-accented'

export default {
  components: { LightButton, MultiSelectChooser, SelectedValueAccented },

  props: {
    initialValues: {
      type: Array,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    selectedValueDisplayVariety: {
      type: String,
      default: 'accent'
    }
  },

  emits: ['change', 'show-chooser'],

  data() {
    return {
      chooserOpen: false,
      values: this.options.filter((option) => this.initialValues.includes(option[1]))
    }
  },

  computed: {
    allValuesSelected() {
      return this.values.length === this.options.length
    },

    showAddButton() {
      return !this.chooserOpen && !this.allValuesSelected
    }
  },

  methods: {
    emitChange() {
      this.$emit('change', this.values.map((item) => item[1]))
    },

    hideChooser() {
      this.chooserOpen = false
    },

    itemSelected(item) {
      this.hideChooser()
      this.values.push(item)
      this.emitChange()
    },

    removeItem(itemValue) {
      this.hideChooser()
      this.values = this.values.filter(it => it[1] !== itemValue)
      this.emitChange()
    },

    showChooser() {
      this.chooserOpen = true
      this.$emit('show-chooser')
    }
  }
}
</script>

<style lang="scss" scoped>
.chooser-container {
  display: inline-block;
  position: relative;
}

.block {
  display: block;
}

.chooser {
  font-size: 14px;
  padding: 10px;
  width: 295px;
  color: black;
}

.selected-value {
  min-height: auto;
  margin-top: 2.5px;
  margin-bottom: 2.5px;
}
</style>
